import * as types from '../constants/ActionTypes';
import store from '../store/store';

import api from '../../config/api.js';


export function resetMediaUploadState(){
    return store.dispatch({
        type: types.RESET_MEDIA_UPLOAD_STATE,
        payload: null,
    })
}

export function openCloseMediaUpload(bool) {
    if(!bool){
        resetMediaUploadState()
    }
    return store.dispatch({
        type: types.SHOW_HIDE_MEDIA_UPLOAD,
        payload: bool,
    })
}

export function setVisibleUploadComponent(value){
    let userId = store.getState().User.User.uid
    if(value === "uploadDocument"){
        setUploadPath(`images/users/${userId}/sessions/documents/`)
    }
    if(value === "uploadPhoto"){
        setUploadPath(`images/users/${userId}/sessions/`)
    }

    return store.dispatch({
        type: types.SET_VISIBLE_UPLOAD_COMPONENT, 
        payload: value
    })
}

export function setCurrentSessionInStore(session){
    setIsSession(true)
    return store.dispatch({
        type: types.SET_CURRENT_SESSION, 
        payload: session
    })
}


export function setCurrentPatientInSessionObj(patientId){
    setIsSession(true)
    return store.dispatch({
        type: types.SET_CURRENT_PATIENT_IN_SESSION, 
        payload: patientId
    })
}



export function setIsSession(bool){
    return store.dispatch({
        type: types.SET_IS_SESSION, 
        payload: bool
    })
}

export function setUploadPath(path){
    return store.dispatch({
        type: types.SET_UPLOAD_PATH, 
        payload: path
    })
}

export function setIsInternalUpload(bool){
    return store.dispatch({
        type: types.SET_IS_INTERNAL_UPLOAD, 
        payload: bool
    })
}

export function setSessionName(name){
    return store.dispatch({
        type: types.SET_SESSION_NAME, 
        payload: name
    })
}

export function setUploadedImage(image){
    return store.dispatch({
        type: types.SET_UPLOADED_IMAGE, 
        payload: image
    })
}

export function setUploadedDocument(document){
    return store.dispatch({
        type: types.SET_UPLOADED_DOCUMENT, 
        payload: document
    })
}

export function setScopeAndSessionType(object){
    return store.dispatch({
        type: types.SET_SCOPE_AND_SESSION_TYPE, 
        payload: object
    })
}

export function createGalleryItem(payload){
    return api.post('/gallery/create', payload)
            .then((result)=>{
                console.log("result of gallery item", result)
                return result.data
            })
            .catch((err) => console.error(err))
}

export function createVideoGalleryItem(payload){
    var config = {
        onUploadProgress: (progressEvent) => {
            console.log(progressEvent);
            var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            console.log(percentCompleted)
            store.dispatch({
                type: types.SET_VIDEO_UPLOAD_PERCENTAGE,
                payload: percentCompleted
            });
        }
    };
    return api.post('/gallery/video', payload, config)
            .then((result)=>{
                console.log("result of video item", result)
                store.dispatch({
                    type: types.SET_VIDEO_UPLOAD_PERCENTAGE,
                    payload: 'processing'
                });
                return result.data
            })
            .then((data) => {
                return store.dispatch({
                    type: types.SET_VIDEO_CURRENTLY_UPLOADING, 
                    payload: data
                })
            })
            .catch((err) => console.error(err))
}

export function pollingForVideo(id){
    return api.get(`/gallery/${id}`)
            .then((result)=>{
                return result.data[0]
            })
            .then((data) => {
                return store.dispatch({
                    type: types.SET_VIDEO_CURRENTLY_UPLOADING, 
                    payload: data
                })
            })
            .catch((err) => console.error(err))
}


// WEBPACK FOOTER //
// ./src/actions/media_upload.js